<template>
  <div class="modal-overlay" @click="$emit('close-admin-modal')">
    <div class="card" @click.stop>
      <div class="card-header">
        <i class="fa fa-lock text-primary me-2" />
        Change user role
      </div>
      <hr class="horizontal dark m-0" />

      <el-form
        ref="changeRoleFormRef"
        :model="changeRoleForm"
        :rules="rules"
        label-width="120px"
        size=""
        status-icon
        :scroll-to-error="true"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 mb-3">
              <el-form-item label="Select New Role" prop="role_id">
                <el-select-v2
                  v-model="changeRoleForm.role_id"
                  filterable
                  :options="roles"
                  placeholder="Please select a role"
                  style="width: 100%"
                />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="card--footer">
          <button
            class="btn mb-0 btn-danger btn-xs"
            @click="$emit('close-add-user-modal')"
          >
            Cancel
          </button>
          <el-button
            type="success"
            :loading="isLoading"
            @click="submitForm(changeRoleFormRef)"
            >Submit</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="close bg-danger" @click="$emit('close-add-user-modal')">
      <i class="fa fa-times" />
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from "vue";
import { fetchRoles } from "../../api/services/authentication";
import { changeUserRole } from "../../api/services/users";
import { ElNotification } from "element-plus";
const changeRoleFormRef = ref();
const isLoading = ref(false);
const organizations = ref([]);
const roles = ref([]);
export default {
  name: "change-user-role",
  props: {
    user_details: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    const changeRoleForm = reactive({
      organization_id: "",
      role_id: "",
      user_id: props?.user_details?.id || 0,
    });
    const rules = reactive({
      role_id: [
        {
          required: true,
          message: "Please select a role",
          trigger: ["blur", "change"],
        },
      ],
    });
    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          isLoading.value = true;
          const formData = new FormData();

          formData.append("role_id", changeRoleForm.role_id);
          formData.append("user_id", changeRoleForm.user_id);

          changeUserRole(formData)
            .then((data) => {
              isLoading.value = false;
              if (data.success) {
                ElNotification({
                  title: "Success",
                  message: data.message,
                  type: "success",
                });
                emit("close-add-user-modal");
              } else {
                Object.values(data.errors).forEach((val) =>
                  ElNotification({
                    title: "Error",
                    message: val[0],
                    type: "error",
                  })
                );
              }
            })
            .catch((err) => {
              isLoading.value = false;
              ElNotification({
                title: "Error",
                message: err.message,
                type: "error",
              });
            })
            .finally(() => {
              isLoading.value = false;
            });
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    const loadRoles = async () => {
      try {
        const response = await fetchRoles();

        const tempRoles = response.data.data.map((role) => ({
          value: `${role.id}`,
          label: `${role.name}`,
        }));
        roles.value = tempRoles;
      } catch (error) {
        console.log(error);
      }
    };
    onMounted(() => {
      loadRoles();
    });
    return {
      loadRoles,
      rules,
      organizations,
      submitForm,
      changeRoleForm,
      changeRoleFormRef,
      isLoading,
      roles,
      props,
    };
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.card {
  margin-top: 5%;
  outline: 0;
  border-radius: 7px;
  max-width: 550px;
  max-height: 420px;
  box-shadow: 0 10px 20px -8px rgba(0, 0, 0, 0.15);
}
.card-body {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}

.card-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.2rem !important;
}
.card--footer {
  display: flex;
  justify-content: space-between;
  padding: 0 1.2rem 1.2rem 1.2rem !important;
}
.close {
  margin: 5% 0 0 10px;
  cursor: pointer;
  color: #fff;
  border: 2px solid #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}

input {
  border-radius: 6px;
}
</style>
